import { User } from '../../../../types';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const getBdmUsers = (
  constructGet: ConstructGet,
): Promise<NonPaginatedResponse<User[]> | undefined> =>
  constructGet<NonPaginatedResponse<User[]>>(`${MIDDLE_OFFICE_BASE_PATH}/bdm`);
